// extracted by mini-css-extract-plugin
module.exports = {"App":"_2vBGDjWDi9-6QYyuXTdXZZ"};